<nb-card>
  <nb-card-header *ngIf="lecture.sourceType !== ''">
    <div class="details">
      <div class="text-basic">{{ lecture.title }}</div>
      <div class="description">
        {{ lecture.description }}
      </div>
    </div>
  </nb-card-header>

  <nb-card-body
    *ngIf="lecture.sourceType == 'images' && lecture.imagesUrl.length > 0"
  >
    <ngx-view-gallery [imagesUrl]="lecture.imagesUrl"> </ngx-view-gallery>
  </nb-card-body>

  <nb-card-body *ngIf="lecture.sourceType == 'video' && lecture.videoUrl">
    <ngx-view-video [url]="lecture.videoUrl"></ngx-view-video>
  </nb-card-body>

  <nb-card-body *ngIf="lecture.sourceType == 'document' && lecture.content">
    <ngx-view-document [content]="lecture.content"> </ngx-view-document>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like [lecture]="lecture"> </ngx-view-like>

      <button nbButton ghost status="info" size="small" (click)="reply()">
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="!lecture.noComment || lecture.noComment == 0">
          Bình luận
        </div>

        <div *ngIf="lecture.noComment > 0" style="text-transform: lowercase">
          &nbsp;Xem <span>{{ lecture.noComment | number }} </span> bình luận
        </div>
      </button>

      <ngx-button-report-spam [lecture]="lecture"></ngx-button-report-spam>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [lecture]="lecture"
          [mode]="mode"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
